import type { TransferMatterOwnershipResponse } from '@/matter/store/schemas'

export interface MatterCollaborator {
  userId: string
  displayName: string
  email: string
  orgRole: 'admin' | 'user' | null
  /** The UI label for the 'collaborator' wire value is "Contributor". */
  matterRole: 'owner' | 'collaborator' | 'editor'
  addedAt: string
}

export interface OrgUserOption {
  userId: string
  displayName: string
  email: string
}

export enum MemberListStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum AddMembersStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

/** Outcome of a single member removal; null = success, string = inline error message. */
export type RemoveMemberResult = string | null
export type TransferOwnershipResult = { ok: true; response: TransferMatterOwnershipResponse } | { ok: false; message: string }
